import React from "react"
import { RichText as PrismicRichText } from "prismic-reactjs"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Element, Text } from "legacy/components/shared/base"
import Link from "legacy/components/shared/Link"
import { Maybe } from "types/Maybe"
import { PrismicBlogPostDataBodyHeroPrimaryType } from "types/__generated__/gatsby-graphql"

interface OwnProps {
  data: Maybe<PrismicBlogPostDataBodyHeroPrimaryType>
  url: string
}

export type ColumnTextProps = OwnProps

const ColumnText: React.FC<ColumnTextProps> = ({
  data,
  url,
}): React.ReactElement | null => {
  if (!data?.post_subtitle || !data?.post_title) return null
  const { t } = useTranslation("shared", {
    keyPrefix: "blog_home.recent_posts",
  })

  const { post_subtitle, post_title } = data
  return (
    <>
      <Text
        as="h2"
        fontSize={["22", "text.subheader"]}
        fontWeight="800"
        lineHeight={["28px", "1.3"]}
        mb={["15", "20"]}
        variant="subheader"
        width="100%"
      >
        {PrismicRichText.asText(post_title.richText)}
      </Text>
      <Text
        as="p"
        fontSize={["17", "text.body"]}
        lineHeight={["28px", "1.8"]}
        mb={["35", "50"]}
        variant="body"
      >
        {PrismicRichText.asText(post_subtitle.richText)}
      </Text>
      <Element mt="auto">
        <Link to={url} variant="buttonSecondary">
          {t("read_more")}
        </Link>
      </Element>
    </>
  )
}

export default ColumnText
